import i18next from 'i18next'
import React from 'react'
import { fromJSX, Updater, Widget } from 'widgets-for-react'
import { NotFoundLayout } from './notFoundLayout'
import { NotFoundState } from './notFoundState'

export const notFoundWidget = (
  state: NotFoundState
): Widget<Updater<NotFoundState>> => fromJSX(() => <NotFoundLayout />)
